import React from "react";
import { SVG } from "~components";
import cn from "classnames";
import * as styles from "./styles.module.scss";

/** ============================================================================
 * @component
 * Spinning star shaped button
 *
 * @param 	{node}  			children			 Button text content
 * @param 	{boolean} 	  light  				 Renders with light theme
 * @param 	{string} 	  	className  		 For additional styling config
 * @param 	{boolean} 	  display  		 	 Display only, no functionality
 * @return	{node}
 */

const StarButton = ({ children, light, className, display }) => {
  const Element = display ? `div` : `button`;

  return (
    <Element
      type={display ? null : `button`}
      className={cn(styles.button, className, {
        [styles.light]: light,
        [styles.display]: display
      })}
    >
      <SVG svg="starButton" className={styles.star} />
      <span className={cn(`h4`, styles.text)}>{children}</span>
    </Element>
  );
};

export default StarButton;
